import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import type { ReactNode } from 'react';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      gcTime: 1000 * 60 * 60,
      refetchOnWindowFocus: true,
      retry: 1
    },
    mutations: {
      retry: 0
    }
  }
});

const persister =
  typeof window !== 'undefined'
    ? createSyncStoragePersister({ storage: window.localStorage, key: 'service-companion-query-cache' })
    : undefined;

export function QueryProvider({ children }: { children: ReactNode }) {
  if (!persister) {
    return <>{children}</>;
  }

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: 1000 * 60 * 60 * 24
      }}
    >
      {children}
    </PersistQueryClientProvider>
  );
}
